module.exports = "<div class=\"c-profile__section c-profile__reviews\" @fadeInUp>\n    <div class=\"c-profile__section_intro c-profile__reviews_intro animate-fadeinup\">\n        <h2>Export CSV</h2>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/exportcsv.component.html
// module id = ./src/app/admin/exportcsv.component.html
// module chunks = main